import DisplayData from "../Components/RecordPage/DisplayData";
import { useEffect, useState } from "react";
import RouteDialog from "../Components/Homepage/RouteDialog";
import { GetSearchData } from "../Components/CRUDPage/FetchData";
import { useNavigate } from "react-router-dom";
import { LogInURL } from "../Variables/variable";

const InfoList = ["patient_id", "name"];
const InfoText = {patient_id:"病例號", name:"姓名"}
let InfoContent = [];
// let testRecords = [];

TestRecord.defaultProps = {
  WhichPage: 'test_record',
};
function TestRecord({WhichPage}) {
    const [targetRoute, setTargetRoute] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [patientData, setPatient] = useState('');

    let navigate = useNavigate();
    useEffect(() => {
        const isLoggedIn = sessionStorage.getItem('isLoggedIn');
        if((!isLoggedIn || isLoggedIn==='false') && !sessionStorage.getItem('access_token')){
            console.log('log out')
            window.location.href = LogInURL;
        }
    }, [navigate])
    
    window.addEventListener('storage', function(e){
        // console.log(e)
        const isLoggedIn = sessionStorage.getItem('isLoggedIn');
        if((!isLoggedIn || isLoggedIn==='false') && !sessionStorage.getItem('access_token')){window.location.href = LogInURL;}
    })   

    const handleOpen = (target, isOpen, patientData) => {
        setTargetRoute(target);
        setIsOpen(isOpen);
        setPatient(patientData);
    }
    const handleClose = () => {
        setTargetRoute(null);
        setIsOpen(false);
        setPatient({patient_id:'', name:''});
    }

    let gettingData = GetSearchData("client_data");

    if(gettingData.message && gettingData.message === 'Unauthenticated.'){
        console.log("error:",gettingData)
        return(<><h1 className="text-xl flex justify-center p-4">{"some error occured"}</h1></>)
    }
    else if(typeof gettingData === "object" && !gettingData.hasOwnProperty("message")){
        InfoContent = gettingData.data;
    }
    else{
        return (<><h1 className="text-xl flex justify-center p-4">{gettingData}</h1></>)
    }

    return(
        <>
            {/* <a>{test}</a> */}
            <DisplayData InfoList={InfoList} InfoText={InfoText} handleDialogOpen={handleOpen} InfoContent={InfoContent} WhichPage={WhichPage}></DisplayData>
            <RouteDialog isOpen={isOpen} targetRoute={targetRoute} handleDialogClose={handleClose} patientData={patientData}></RouteDialog>
        </>

    )
}

export default TestRecord;